export const nameEditFormStyles = {
	title: {
		fontWeight: 700
	},

	actions: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		gap: 1,
		pt: 0.5
	},

	submitButtonDisabled: {
		'&.Mui-disabled': {
			backgroundColor: 'grey.300',
			opacity: 1
		}
	}
};
